import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LpnPageSchema = withDefaults({
  type: 'lpn-page',
  objectExtensions: ['lpn-page'],
  fields: [
    {
      kind: 'attribute',
      name: 'badgeCappedTuition',
    },
    {
      kind: 'attribute',
      name: 'badgeDiscount',
    },
    {
      kind: 'attribute',
      name: 'badgeFamilySavings',
    },
    {
      kind: 'attribute',
      name: 'badgeFeesWaived',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'discountPercent',
    },
    {
      kind: 'attribute',
      name: 'schoolName',
    },
    {
      kind: 'attribute',
      name: 'url',
    },
    {
      kind: 'attribute',
      name: 'dapip_id',
    },
    {
      kind: 'attribute',
      name: 'institutionIdentifier',
    },
    {
      kind: 'attribute',
      name: 'isCompanyCreated',
    },
    {
      kind: 'attribute',
      name: 'providedBy',
    },
    {
      kind: 'attribute',
      name: 'badgeCappedTuitionRange',
    },
    {
      kind: 'attribute',
      name: 'discountPercentRange',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmountRange',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmountValue',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmount',
    },
    {
      kind: 'attribute',
      name: 'partTuitionWaiver',
    },
    {
      kind: 'attribute',
      name: 'lowTuition',
    },
    {
      kind: 'attribute',
      name: 'costPerCredit',
    },
    {
      kind: 'attribute',
      name: 'costPerCreditRange',
    },
    {
      kind: 'attribute',
      name: 'format',
    },
    {
      kind: 'attribute',
      name: 'programs',
    },
    {
      kind: 'attribute',
      name: 'areasOfStudy',
    },
    {
      kind: 'attribute',
      name: 'imageUrl',
    },
    {
      kind: 'attribute',
      name: 'useDiscountPercentRange',
    },
    {
      kind: 'attribute',
      name: 'useSaveDollarAmountRange',
    },
    {
      kind: 'attribute',
      name: 'useCostPerCreditRange',
    },
    {
      kind: 'hasMany',
      name: 'companyLpnSettings',
      type: 'company-lpn-setting',
      options: {
        async: true,
        inverse: 'lpnPage',
      },
    },
  ],
});

export default LpnPageSchema;
